export default "__VITE_ASSET__Ccy9KO_H__"